<template>
  <div class="main">
    <img class="notice-img" src="@/assets/notion-ic.png" />
    <p class="text-line1">다른 TV에서 중복 로그인 되었습니다</p>
    <button class="focused" @click="enterKeyProc" ref="button">종료하기</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActiveVue: true,
    };
  },

  computed: {
    keyInput() {
      return this.$store.getters.keyInput;
    },
  },
  watch: {
    keyInput(val, oldVal) {
      if (this.isActiveVue) {
        switch (val.key) {
          case "Enter":
            this.enterKeyProc();
            break;
        }
      }
    },
  },

  methods: {
    enterKeyProc(keyInput) {
      this.$router.replace({
        name: "login",
        params: {
          t: new Date().getTime(),
        },
      });
    },
  },

  created() {
    this.$progress.$emit("off:progress");
    this.$store.dispatch("REQUEST_LOGOUT");
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.main {
  margin-top: 310px;
  text-align: center;
}
.notice-img {
  width: 128px;
  height: 128px;
}
.text-line1 {
  font-size: 56px;
  line-height: 1;
  color: #eeeeee;
  margin: 40px 0;
}
button {
  width: 272px;
  height: 80px;
  background-color: #3e3e3e;
  font-size: 28px;
  color: #eeeeee;
  margin-top: 40px;
  border: none;
}
button.focused {
  border: solid 4px #eeeeee;
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .main {
    margin-top: 240px;
    text-align: center;
  }
  .notice-img {
    width: 64px;
    height: 64px;
  }
  .text-line1 {
    font-size: 32px;
    line-height: 1;
    color: #ffffff;
    margin: 40px 0 0px;
  }
  button {
    width: 160px;
    height: 56px;
    background-color: #3e3e3e;
    font-size: 18px;
    color: #ffffff;
    margin-top: 48px;
    border: none;
    font-weight: bold;
  }
  button.focused {
    border: solid 3px #ffffff;
  }
}
</style>
